export default class Provider {
  constructor(providerID, providerName, providerDefaultLookupType) {
    this.providerID = providerID;
    this.providerName = providerName;
    this.providerDefaultLookupType = providerDefaultLookupType;
  }
}
